module.exports = __webpack_public_path__ + "img/banner4.2816d4b5.jpeg";